import React, { Dispatch, useState } from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import Button from "@material-ui/core/Button";
import { DASH } from "common/constants";

import {
  checkStableEntryStatus,
  StallApplicationCheckboxType,
  TAction
} from "../helper";
import { transformViewDate } from "utils/date-utils";
import StableEntryStateCheckbox from "../StableEntryStateCheckbox/StableEntryStateCheckbox";
import PastPerformanceItem from "./PastPerformanceItem";
import HorseDetailsModal from "./HorseDetailsModal";
import useStyles from "./styles";

interface IProps {
  shouldDisplayPPs?: boolean;
  entry: racehorse360.IStableEntry;
  dispatch: Dispatch<TAction>;
}

const StableEntry = (props: IProps) => {
  const { shouldDisplayPPs, entry, dispatch } = props;

  const classes = useStyles();

  const [areHorseDetailsOpen, setAreHorseDetailsOpen] = useState(false);

  const horseName = entry.customHorseName || entry.horse.name;
  const registrationNumber =
    entry.customHorseRegistrationNumber ||
    entry.horse?.registrationNumber ||
    DASH;
  const { isApproved, isDenied } = checkStableEntryStatus(entry.status);
  const horseInfoContent = `${
    entry.raceReadyDate
      ? `- Race Ready ${transformViewDate(entry.raceReadyDate)}`
      : ""
  }`;

  const handleOpenHorseDetails = () => {
    setAreHorseDetailsOpen(true);
  };

  const renderPPs = () => {
    if (!entry.horse) return;

    return entry.horse.lastTenPastPerformances?.map(pp => (
      <PastPerformanceItem key={pp.id} pastPerformance={pp} />
    ));
  };

  return (
    <div className={classes.root}>
      <div className={classes.stableEntry}>
        <div>
          <div className={classes.horseName}>{horseName}</div>
          <div className={classes.horseInfo}>
            <Button
              className={classes.viewHorseDetail}
              onClick={handleOpenHorseDetails}
              disableRipple={true}
            >
              View Details
            </Button>
            <span>&nbsp;{horseInfoContent}</span>
          </div>
        </div>

        <div className={classes.checkboxes}>
          <StableEntryStateCheckbox
            type={StallApplicationCheckboxType.DENY}
            checked={isDenied}
            entryId={entry.id}
            dispatch={dispatch}
          />
          <StableEntryStateCheckbox
            type={StallApplicationCheckboxType.APPROVE}
            checked={isApproved}
            entryId={entry.id}
            dispatch={dispatch}
          />
        </div>
      </div>

      {shouldDisplayPPs && <div>{renderPPs()}</div>}

      {areHorseDetailsOpen && (
        <HorseDetailsModal
          horseId={entry.horse?.id}
          horseName={horseName}
          registrationNumber={registrationNumber}
          raceReady={transformViewDate(entry.raceReadyDate)}
          onClose={setAreHorseDetailsOpen}
        />
      )}
    </div>
  );
};

export default React.memo(StableEntry);
